import {z} from 'zod';

const RECENT_VISITS_KEY = 'navigation_recent_visits';
const MAX_RECENT_VISITS = 5;

const recentVisitSchema = z.object({
    path: z.string(),
    timestamp: z.number(),
});

type RecentVisitType = z.infer<typeof recentVisitSchema>;

function isRecentVisitArray(data: unknown): data is Array<RecentVisitType> {
    return recentVisitSchema.array().safeParse(data).success;
}

function getStoredVisits(): Array<RecentVisitType> {
    try {
        const raw = window.sessionStorage.getItem(RECENT_VISITS_KEY);

        if (!raw) {
            return [];
        }

        const parsed: unknown = JSON.parse(raw);

        if (isRecentVisitArray(parsed)) {
            return parsed;
        }

        return [];
    } catch {
        return [];
    }
}

function saveVisits(visits: Array<RecentVisitType>): void {
    try {
        window.sessionStorage.setItem(RECENT_VISITS_KEY, JSON.stringify(visits));
    } catch {
        // ignore
    }
}

export function getRecentVisits(): Array<RecentVisitType> {
    return getStoredVisits().slice(0, MAX_RECENT_VISITS);
}

export function addRecentVisit(path: string): void {
    const normalizedPath = path.replace(/\/+$/, '') || '/';
    const visits = getStoredVisits();
    const filtered = visits.filter((visit) => visit.path !== normalizedPath);
    const updated = [{path: normalizedPath, timestamp: Date.now()}, ...filtered].slice(0, MAX_RECENT_VISITS);

    saveVisits(updated);
}
